import React, { useEffect, useState } from 'react';
import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
import { IconButton, InputAdornment, styled } from '@mui/material';

import { InputText } from '../Input';

import './style.css';

const Div = styled('div')({ display: 'flex', justifyContent: 'flex-start' });

export default function SearchMobileView({
  filterValues,
  setFilterValues,
  placeholder = 'Search',
}) {
  const [values, setValues] = useState(filterValues);
  useEffect(() => {
    setValues(filterValues);
  }, [filterValues]);

  const handleChange = (event) => {
    const searchValue = event.target.value;
    setValues((prevValues) => {
      return { ...prevValues, searchValue };
    });
    if (filterValues?.searchValue?.length > 0 && searchValue.length === 0) {
      setFilterValues({ ...values, searchValue: '' });
    }
  };

  const handelSearch = () => {
    if (
      values?.searchValue?.trim().length >= 2 ||
      (!values?.searchValue?.length && filterValues?.searchValue?.length > 0)
    ) {
      setFilterValues({ ...values, searchValue: values?.searchValue?.trim() });
    }
  };

  const handleKeyPress = (event) => {
    if (
      event.key === 'Enter' &&
      (values?.searchValue?.trim().length >= 2 ||
        (!values?.searchValue?.length && filterValues?.searchValue?.length > 0))
    ) {
      setFilterValues({ ...values, searchValue: values?.searchValue?.trim() });
    }
  };

  const handleClear = () => {
    if (values.searchValue) {
      setValues({ ...values, searchValue: '' });
    }

    if (filterValues?.searchValue) {
      setFilterValues({ ...values, searchValue: '' });
    }
  };

  useEffect(() => {
    document.getElementById('application-mobileSearch').focus();
  }, []);

  return (
    <Div>
      <InputText
        placeholder={placeholder}
        value={values.searchValue}
        onChange={handleChange}
        className="hm-search-input"
        sx={{ width: '100%' }}
        onKeyPress={handleKeyPress}
        id="application-mobileSearch"
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <IconButton
                onClick={handelSearch}
                data-testid="testSearchLens"
                className="global-search-icon"
                size="small"
              >
                <SearchIcon fontSize="small" />
              </IconButton>
            </InputAdornment>
          ),
          endAdornment: values.searchValue ? (
            <InputAdornment position="end">
              <IconButton
                onClick={handleClear}
                data-testid="testClearButton"
                className="global-clear-icon"
                size="small"
              >
                <ClearIcon fontSize="small" />
              </IconButton>
            </InputAdornment>
          ) : null,
        }}
      />
    </Div>
  );
}
